module.exports = "<p>\n  O acesso ao SCA2 é restrito a servidores do Ibama, conforme cadastro no SIGER.\n</p>\n"